import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';

export default {
    emitError: (data) => {
        if (!Dispatcher.isDispatching()) {
            return Dispatcher.dispatch({type: ActionTypes.FORM_SUBMIT_ERROR, data});
        }
    },
};
